import constants from "../constants";
import gtm from "../gtm";
var base = require('../../../../../../app_storefront_base/cartridge/client/default/js/product/base');

export function galleryThumb() {
    const changeActiveIndicator = (slide) => {
        const $indicators = $(".primary-images .carousel-indicators");
        const offsetLeft  = $indicators.find(slide ? `li[data-slide-to="${slide}"]` : "li.active")[0].offsetLeft;

        console.log(offsetLeft, $indicators);
        $indicators.animate({ scrollLeft: offsetLeft }, 200);
    };

    $(".primary-images .carousel").on("slide.bs.carousel", (e) => {
        setTimeout(() => changeActiveIndicator(e.to), 50);
    });

    $(".primary-images .carousel-indicators").animate({ scrollLeft: 0 }, 200);

    $(window).on("resize", () => changeActiveIndicator());
}

const PDP_DISPLAY_SCALE = 400;

function withDisScale(url, scaleWidth) {
    if (!url || !scaleWidth) {
        return url || "";
    }

    var decoded = String(url).replace(/&amp;/g, "&");
    var scale   = String(scaleWidth);

    if (/([?&])sw=\d+/i.test(decoded)) {
        decoded = decoded.replace(/([?&])sw=\d+/ig, "$1sw=" + scale);
    } else {
        decoded += (decoded.indexOf("?") === -1 ? "?" : "&") + "sw=" + scale;
    }

    if (/([?&])sh=\d+/i.test(decoded)) {
        decoded = decoded.replace(/([?&])sh=\d+/ig, "$1sh=" + scale);
    } else {
        decoded += "&sh=" + scale;
    }

    if (!/[?&]sm=/i.test(decoded)) {
        decoded += "&sm=fit";
    }

    return decoded;
}

function applyPdpDisplayImageScale($scope) {
    var $root = $scope && $scope.length ? $scope : $(".primary-images");

    $root.find(".carousel-inner .carousel-item img.js-zoom-trigger").each(function (index) {
        var $img    = $(this);
        var fullUrl = $img.attr("data-zoom-src") || $img.attr("src");

        if (!fullUrl) {
            return;
        }

        $img.attr("data-zoom-src", fullUrl);
        $img.attr("src", withDisScale(fullUrl, PDP_DISPLAY_SCALE));
        $img.attr({ width: PDP_DISPLAY_SCALE, height: PDP_DISPLAY_SCALE, decoding: "async" });

        if (index === 0) {
            $img.attr("fetchpriority", "high").removeAttr("loading");
        } else {
            $img.attr("loading", "lazy").removeAttr("fetchpriority");
        }
    });
}

function updateGalleryThumb(e, response) {
    const productData = response.data.product;
    const images      = productData.images.large;
    const thumbImages = (productData.images.small && productData.images.small.length)
        ? productData.images.small
        : images;

    const $indicators = $(".primary-images .carousel-indicators");

    $indicators.empty();

    if (images.length > 1) {
        $(".primary-images").removeClass("primary-images-no-indicators");
    } else {
        $(".primary-images").addClass("primary-images-no-indicators");
    }

    thumbImages.forEach((image, index) => {
        const $indicator = $(`<li data-target="#pdpCarousel-${productData.id}" data-slide-to="${index}" class="${index === 0 ? "active" : ""}"></li>`);
        const $img       = $(`<img src="${image.url}" alt="${image.alt} image number ${image.index}" itemprop="image" loading="lazy" width="80" height="80" decoding="async" />`);

        $indicator.append($img);
        $indicators.append($indicator);

        $indicator.off("click").on("click", function () {
            $(".primary-images .carousel").carousel(index);
        });
    });

    applyPdpDisplayImageScale($(response.container || ".product-detail").find(".primary-images"));
    galleryThumb();
}

function fetchVariationInfo() {
    const variationsInfoUrl = $("span[data-variationinfourl]");

    variationsInfoUrl.each(function () {
        const $this = $(this);
        const url   = $this.data("variationinfourl");

        $.ajax({
            url,
            type: "GET",
            success: function (response) {
                if (response && response.price) {
                    const productPrice = response.price;

                    if (!productPrice.sales) {
                        return;
                    }

                    const productPriceFormatted = `
                        <span>${productPrice.sales.formatted}</span>
                        <small>em até ${response.parcelamento.qtdeParcelas}x R$ ${response.parcelamento.valorParcela.toString().replace(".", ",")} s/ juros</small>
                    `;

                    $this.html(productPriceFormatted).removeClass("loading");
                }
            }
        });
    });
}

function updateSpecificHtml(containerSelector, html, $productContainer) {
    $productContainer.find(containerSelector).empty().html(html);
}

export function initDetails() {
    fetchVariationInfo();

    const $applianceTrackingButton = $(".js-add-regular-item-to-cart, .js-appliance-assisted-sale").first();

    if ($applianceTrackingButton.length) {
        gtm.trackApplianceViewItem($applianceTrackingButton);
    }

    $(".js-appliance-assisted-sale").on("click", function () {
        gtm.trackApplianceSelectItem($(this));
    });

    $("body").on("product:afterAttributeSelect", function (e, response) {
        const responseData = response.data;
        const product      = responseData.product;
        const urls         = responseData.urls;

        const $productContainer = $(response.container);

        console.log(responseData);

        $productContainer.find(".product-name").text(product.productName);
        $productContainer.find(".product-brand").text(product.brand);
        $productContainer.find(".product-brand").text(product.brand);

        const $trackingButtons = $productContainer.find(".js-add-regular-item-to-cart, .js-appliance-assisted-sale");

        $trackingButtons
            .attr("data-pid", product.id)
            .attr("data-item-name", product.productName || "");

        if (product.price && product.price.sales) {
            $trackingButtons.attr("data-item-price", product.price.sales.value || 0);
        }

        // data-insurance-url é renderizado no load da página com o pid do aparelho
        // exibido naquele momento (addToCartProduct.isml). Trocar a variação (ex.: cor)
        // só atualiza data-pid via JS acima, então sem isto "Comprar Agora" continuava
        // redirecionando pro Product-Insurance da cor antiga.
        $trackingButtons.each(function () {
            const $button             = $(this);
            const currentInsuranceUrl = $button.attr("data-insurance-url");

            if (currentInsuranceUrl) {
                const insuranceUrl = new URL(currentInsuranceUrl, window.location.origin);

                insuranceUrl.searchParams.set("pid", product.id);

                $button.attr("data-insurance-url", insuranceUrl.pathname + insuranceUrl.search);
            }
        });

        if (urls && urls.product) {
            window.history.replaceState(null, document.title, urls.product);
        }

        updateSpecificHtml(".product-attributes", product.variationsHtml, $productContainer);
        updateSpecificHtml(".pdp-product-description", product.descriptionHtml, $productContainer);

        fetchVariationInfo();
        updateGalleryThumb(e, response);
    });
}

function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

function isMobile() {
    return navigator.userAgent.toLowerCase().includes('mobile/');
}

function appendCurrentPreviewParams(url) {
    const previewParams  = [
        "__siteDate",
        "__sourceCode",
        "__customerGroup",
        "__abTest",
        "__abTestSegment",
        "__previewID"
    ];
    const currentParams  = new URLSearchParams(window.location.search);
    const paramsToAppend = new URLSearchParams();

    previewParams.forEach((param) => {
        if (currentParams.has(param)) {
            paramsToAppend.set(param, currentParams.get(param) || "");
        }
    });

    if (!paramsToAppend.toString()) {
        return url;
    }

    const urlObject = new URL(url, window.location.origin);

    previewParams.forEach((param) => {
        urlObject.searchParams.delete(param);
    });

    paramsToAppend.forEach((value, key) => {
        urlObject.searchParams.set(key, value);
    });

    return url.indexOf("http") === 0
        ? urlObject.toString()
        : urlObject.pathname + urlObject.search + urlObject.hash;
}

export function initInsuranceRedirect() {
    document.addEventListener('click', function (e) {
        var target = e.target;

        while (target && target !== document.body) {
            if (target.hasAttribute && target.hasAttribute('data-insurance-url')) {
                var url = target.getAttribute('data-insurance-url');

                if (url) {
                    e.stopPropagation();

                    // "Comprar Agora" (js-add-regular-item-to-cart) pula o fluxo normal de
                    // add-to-cart via ajax (onde o back-end decide isEmptyCartRequired) e redireciona
                    // direto pra Product-Insurance. Sem essa checagem o modal de "esvaziar carrinho"
                    // parava de aparecer quando já havia item no carrinho, pois o clique nunca chegava
                    // no handler de product:afterAddToCart (addToCart(), abaixo) que o exibe.
                    var $target      = $(target);
                    var $minicartQty = $('.js-minicart-qty');

                    if ($target.hasClass('js-add-regular-item-to-cart') && $minicartQty.length && !$minicartQty.attr('hidden')) {
                        e.preventDefault();

                        var $cartConflictModal = $('.js-cart-conflict-modal');
                        var emptyCartUrl       = $target.data('empty-cart-url');

                        $cartConflictModal.toggleClass('show', true);

                        $('.js-cart-conflict-close', $cartConflictModal).off('click').on('click', function () {
                            $cartConflictModal.toggleClass('show', false);
                        });

                        $('.js-cart-conflict-submit', $cartConflictModal).off('click').on('click', function () {
                            $.ajax({
                                url: emptyCartUrl,
                                type: 'get'
                            }).done(function () {
                                $cartConflictModal.toggleClass('show', false);
                                window.location.href = url;
                            });
                        });

                        return;
                    }

                    window.location.href = url;
                }
                return;
            }
            target = target.parentNode;
        }
    }, true);
}

export function showApplianceModal() {
    $(document).on('click', '.show-buy-modal', function () {
        var insuranceUrl = $(this).data('insurance-url');

        if (insuranceUrl) {
            window.location.href = insuranceUrl;
            return;
        }

        let pid;
        let timerInterval;
        let countdownTime;

        pid = getPidValue($(this));

        const $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        const form = {
            pid: pid,
        };

        $(this).trigger('updateAddToCartFormData', form);

        $('#modal-appliance-products').modal('show');
        $('#modal-appliance-products').css('display', 'flex');

        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        $(".js-appliance-modal-close").on("click", () => {
            $('#modal-appliance-products').toggleClass("show", false);
            $('#modal-appliance-products').css('display', 'none');
            clearInterval(timerInterval);
        });

        const whatsappNumber = "5534998607072";
        const whatsappMessage = encodeURIComponent(
            `${constants.APPLIANCE.MESSAGE_WPP}  ${pid} ${constants.APPLIANCE.MESSAGE_WPP_END}`
        );

        $("#continue-whatsapp-link").attr("href", "https://wa.me/" + whatsappNumber + "?text=" + whatsappMessage);

        const $timer = $('#timer');
        countdownTime = 15;
        $timer.text(countdownTime);

        clearInterval(timerInterval);
        timerInterval = setInterval(function () {
            countdownTime--;
            $timer.text(countdownTime);

            if (countdownTime <= 0) {
                clearInterval(timerInterval);

                if (isMobile()) {
                    window.location.assign($("#continue-whatsapp-link").attr("href"));
                } else {
                    $("#continue-whatsapp-link")[0].click();
                }
            }
        }, 1000);

        $('#modal-appliance-products').on('hidden.bs.modal', function () {
            clearInterval(timerInterval);
        });

        $("#continue-whatsapp-link").on("click", function () {
            clearInterval(timerInterval);
            $(".js-appliance-modal-close")[0].click();
        });
    });
}

const updateCartCounter = (numberOfProducts) => {
    const $cartProductCounter                 = $(".js-minicart-qty");

    if (numberOfProducts === 0) {
        $cartProductCounter.attr("hidden", "true");
        $cartProductCounter.empty();
    } else {
        $cartProductCounter.removeAttr("hidden");
        $cartProductCounter.empty().text(numberOfProducts);
    }
};

export function colorAttribute() {
    base.colorAttribute();

    $(".product-detail").on("product:updateAvailability", function (e, response) {
        if (response.product.available) {
            $(this).find('.product-tag--out-of-stock').addClass('d-none');
        } else {
            $(this).find('.product-tag--out-of-stock').removeClass('d-none');
        }
    });
}

export function selectAttribute() {
    base.selectAttribute();
}

export function addToCart() {
    const $addToCartButton = $(".js-add-regular-item-to-cart");

    $("body").on("product:beforeAddToCart", function (_evt, _data) {
        const $addToCartUrlInput = $(".add-to-cart-url");
        const addToCartUrl       = $addToCartUrlInput.val();

        if (addToCartUrl) {
            $addToCartUrlInput.val(appendCurrentPreviewParams(addToCartUrl));
        }

        if ($addToCartButton.hasClass("btn-primary")) {
            $addToCartButton.removeClass("btn-primary").addClass("btn-primary-loading").attr("disabled", "true");
        }

        if ($addToCartButton.hasClass("btn-primary-cta-buy")) {
            $addToCartButton.addClass("btn-primary-cta-buy-loading").attr("disabled", "true");
        }
    });

    $("body").on("product:afterAddToCart", function (evt, data) {
        if ($addToCartButton.hasClass("btn-primary")) {
            $addToCartButton.removeClass("btn-primary-loading").addClass("btn-primary").removeAttr("disabled");
        }

        if ($addToCartButton.hasClass("btn-primary-cta-buy")) {
            $addToCartButton.removeClass("btn-primary-cta-buy-loading").addClass("btn-primary-cta-buy").removeAttr("disabled");
        }

        if (!data.error && data.quantityTotal) {
            $(".add-to-basket-alert").remove();

            updateCartCounter(data.quantityTotal);
            const gotoUrl = $addToCartButton.data("goto-url");

            if (gotoUrl) {
                gtm.trackApplianceAddToCart($addToCartButton, function () {
                    window.location.href = appendCurrentPreviewParams(gotoUrl);
                });
            } else {
                gtm.trackApplianceAddToCart($addToCartButton);
            }
        }

        if (data.error && data.isEmptyCartRequired) {
            $(".add-to-basket-alert").remove();

            const $cartConflictModal = $(".js-cart-conflict-modal");
            const submitUrl          = $addToCartButton.data("empty-cart-url");

            $cartConflictModal.toggleClass("show", true);

            $(".js-cart-conflict-close", $cartConflictModal).off("click").on("click", function () {
                $cartConflictModal.toggleClass("show", false);
            });

            $(".js-cart-conflict-submit", $cartConflictModal).off("click").on("click", function () {
                $.ajax({
                    url: submitUrl,
                    type: "get"
                }).done(function () {
                    $cartConflictModal.toggleClass("show", false);
                    $(".js-add-regular-item-to-cart").trigger("click");
                });
            });
        }

    });
}

export function initKnownDetailsIframe() {
    window.addEventListener("message", (event) => {
        if (!event || !event.data || event.data.action !== "DESCRIPTION_IFRAME_LOADED") {
            return;
        }

        const $knownDetailsIframe = $(".product-known-details-container .known-details-iframe");

        if ($knownDetailsIframe.length) {
            $knownDetailsIframe.css("height", event.data.height + "px");
        }
    });
}

export function initImageZoomModal() {
    const $modal   = $("#pdp-image-zoom-modal");
    const $zoomImg = $modal.find(".js-zoom-image");
    const $wrapper = $modal.find(".js-zoom-image-wrapper");

    let images           = [];
    let currentIndex     = 0;
    let zoomLevel        = 1;
    let translate        = { x: 0, y: 0 };

    // Single-pointer state
    let isPointerDown    = false;
    let hasMoved         = false;
    let pointerStart     = { x: 0, y: 0 };
    let translateOnStart = { x: 0, y: 0 };

    // Pinch state
    let isPinching          = false;
    let pinchStartDist      = 0;
    let pinchStartZoom      = 1;
    let pinchStartMid       = { x: 0, y: 0 };
    let pinchStartTranslate = { x: 0, y: 0 };

    const ZOOM_SCALE      = 2.5;
    const MIN_ZOOM        = 1;
    const MAX_ZOOM        = 5;
    const MOVE_THRESHOLD  = 6;
    const SWIPE_THRESHOLD = 50;

    function getTouches(e) { return (e.originalEvent || e).touches; }

    function touchDist(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    function touchMid(touches) {
        return {
            x: (touches[0].clientX + touches[1].clientX) / 2,
            y: (touches[0].clientY + touches[1].clientY) / 2
        };
    }

    function getPoint(e) {
        const orig = e.originalEvent || e;
        if (orig.touches && orig.touches.length)               return orig.touches[0];
        if (orig.changedTouches && orig.changedTouches.length) return orig.changedTouches[0];
        return orig;
    }

    function gatherImages() {
        images = [];
        $(".primary-images .carousel-inner .carousel-item img").each(function () {
            const $img = $(this);

            images.push({
                src: $img.attr("data-zoom-src") || $img.attr("src"),
                alt: $img.attr("alt")
            });
        });
    }

    function applyTransform() {
        $zoomImg.css("transform", `translate(${translate.x}px, ${translate.y}px) scale(${zoomLevel})`);
    }

    function resetZoom() {
        zoomLevel = 1;
        translate = { x: 0, y: 0 };
        $wrapper.css("cursor", "zoom-in");
        applyTransform();
    }

    function showImage(index) {
        if (!images.length) return;
        currentIndex = (index + images.length) % images.length;
        resetZoom();
        $zoomImg.attr("src", images[currentIndex].src).attr("alt", images[currentIndex].alt);
        $modal.find(".pdp-zoom-modal__nav--prev").toggle(images.length > 1);
        $modal.find(".pdp-zoom-modal__nav--next").toggle(images.length > 1);
        $("#counterZoom").text((currentIndex + 1) + "/" + images.length);
    }

    function openModal(index) {
        gatherImages();
        showImage(index);
        $modal.addClass("pdp-zoom-modal--open");
        $("body").addClass("pdp-zoom-modal-open");
    }

    function closeModal() {
        $modal.removeClass("pdp-zoom-modal--open");
        $("body").removeClass("pdp-zoom-modal-open");
        resetZoom();
    }

    $(document).on("click", ".js-zoom-trigger", function () {
        openModal(parseInt($(this).data("index"), 10) || 0);
    });

    $(document).on("click", ".js-zoom-close", closeModal);

    $(document).on("click", ".js-zoom-prev", function (e) {
        e.stopPropagation();
        showImage(currentIndex - 1);
    });

    $(document).on("click", ".js-zoom-next", function (e) {
        e.stopPropagation();
        showImage(currentIndex + 1);
    });

    $(document).on("keydown", function (e) {
        if (!$modal.hasClass("pdp-zoom-modal--open")) return;
        if (e.key === "Escape")     closeModal();
        if (e.key === "ArrowLeft")  showImage(currentIndex - 1);
        if (e.key === "ArrowRight") showImage(currentIndex + 1);
    });

    $wrapper.on("mousedown touchstart", function (e) {
        const touches = getTouches(e);

        // Two fingers → start pinch
        if (touches && touches.length === 2) {
            isPinching          = true;
            isPointerDown       = false;
            hasMoved            = false;
            pinchStartDist      = touchDist(touches);
            pinchStartZoom      = zoomLevel;
            pinchStartTranslate = { x: translate.x, y: translate.y };
            pinchStartMid       = touchMid(touches);
            e.preventDefault();
            return;
        }

        if (e.type === "mousedown" && e.button !== 0) return;
        isPointerDown    = true;
        hasMoved         = false;
        translateOnStart = { x: translate.x, y: translate.y };
        const pt         = getPoint(e);
        pointerStart     = { x: pt.clientX, y: pt.clientY };
        if (zoomLevel > 1) $wrapper.css("cursor", "grabbing");
        e.preventDefault();
    });

    $(document).on("mousemove touchmove", function (e) {
        const touches = getTouches(e);

        // Pinch move
        if (isPinching && touches && touches.length === 2) {
            const newDist  = touchDist(touches);
            const newZoom  = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, pinchStartZoom * (newDist / pinchStartDist)));
            const rect     = $wrapper[0].getBoundingClientRect();
            const cx       = rect.left + rect.width  / 2;
            const cy       = rect.top  + rect.height / 2;
            const ratio    = newZoom / pinchStartZoom;

            // Keep the initial pinch midpoint stationary under the fingers
            zoomLevel = newZoom;
            translate = {
                x: (pinchStartMid.x - cx) * (1 - ratio) + pinchStartTranslate.x * ratio,
                y: (pinchStartMid.y - cy) * (1 - ratio) + pinchStartTranslate.y * ratio
            };
            applyTransform();
            e.preventDefault();
            return;
        }

        if (!isPointerDown) return;
        const pt = getPoint(e);
        const dx = pt.clientX - pointerStart.x;
        const dy = pt.clientY - pointerStart.y;

        if (!hasMoved && (Math.abs(dx) > MOVE_THRESHOLD || Math.abs(dy) > MOVE_THRESHOLD)) {
            hasMoved = true;
        }

        if (hasMoved) {
            if (zoomLevel > 1) {
                translate = { x: translateOnStart.x + dx, y: translateOnStart.y + dy };
                applyTransform();
            }
            e.preventDefault();
        }
    });

    $(document).on("mouseup touchend touchcancel", function (e) {
        const touches = getTouches(e);

        // End pinch when fewer than 2 fingers remain
        if (isPinching) {
            if (!touches || touches.length < 2) {
                isPinching = false;
                if (zoomLevel < 1.05) resetZoom();
                else $wrapper.css("cursor", "zoom-out");
            }
            return;
        }

        if (!isPointerDown) return;
        isPointerDown = false;

        const pt = getPoint(e);
        const dx = pt.clientX - pointerStart.x;

        if (!hasMoved) {
            if (zoomLevel === 1) {
                // Zoom into the exact point that was tapped/clicked
                zoomLevel    = ZOOM_SCALE;
                const rect   = $wrapper[0].getBoundingClientRect();
                const clickX = pointerStart.x - rect.left;
                const clickY = pointerStart.y - rect.top;
                translate    = {
                    x: -(clickX - rect.width  / 2) * (ZOOM_SCALE - 1),
                    y: -(clickY - rect.height / 2) * (ZOOM_SCALE - 1)
                };
                applyTransform();
                $wrapper.css("cursor", "zoom-out");
            } else {
                resetZoom();
            }
        } else if (zoomLevel === 1) {
            // Swipe to navigate
            if (dx > SWIPE_THRESHOLD)       showImage(currentIndex - 1);
            else if (dx < -SWIPE_THRESHOLD) showImage(currentIndex + 1);
        } else {
            $wrapper.css("cursor", "zoom-out");
        }

        hasMoved = false;
    });
}

export function initShippingCalculator() {
    function getShippingTexts(estimatedDelivery) {
        const $calculateBtn = $("#calculate-shipping");
        const $zipcodeInput = $("#shipping-zipcode");

        return {
            deliveryMethod:      $calculateBtn.data("delivery-method"),
            deliveryTime:        `${$calculateBtn.data("delivery-time")} ${estimatedDelivery || ""}`,
            deliveryDescription: $calculateBtn.data("delivery-description"),
            freeShipping:        $calculateBtn.data("free-shipping"),
            errorMessage:        $zipcodeInput.data("error-message"),
            shippingOptionsUrl:  $calculateBtn.data("shipping-options-url"),
            pickupMethod:        $calculateBtn.data("pickup-method"),
            pickupTimePrefix:    $calculateBtn.data("pickup-time-prefix"),
            pickupDescription:   $calculateBtn.data("pickup-description"),
            pickupFreeShipping:  $calculateBtn.data("pickup-free-shipping"),
        };
    }

    function createShippingResultHTML(texts) {
        return `
            <div class="shipping-info js-shipping-info">
                <span class="shipping-icon"></span>
                <div class="shipping-details">
                    <p class="shipping-method">${texts.deliveryMethod} <span class="shipping-time">${texts.deliveryTime}</span></p>
                    <p class="shipping-description">${texts.deliveryDescription}</p>
                </div>
                <div class="shipping-price">
                    <span class="free-shipping">${texts.freeShipping}</span>
                </div>
            </div>
        `;
    }

    // function getPickupDateText(timePrefix) {
    //     const dayNames   = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
    //     const monthNames = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    //     const date       = new Date();
    //     let daysToAdd    = 2;

    //     while (daysToAdd > 0) {
    //         date.setDate(date.getDate() + 1);

    //         if (date.getDay() !== 0 && date.getDay() !== 6) {
    //             daysToAdd--;
    //         }
    //     }

    //     return `${timePrefix} ${dayNames[date.getDay()]}, ${date.getDate()} de ${monthNames[date.getMonth()]}`;
    // }

    function createPickupResultHTML(texts) {
        return `
            <div class="shipping-info js-pickup-info">
                <span class="shipping-icon shipping-icon--pickup"></span>
                <div class="shipping-details">
                    <p class="shipping-method">${texts.pickupMethod}</p>
                    <p class="shipping-description">${texts.pickupDescription}</p>
                </div>
                <div class="shipping-price">
                    <span class="free-shipping">${texts.pickupFreeShipping}</span>
                </div>
            </div>
        `;
    }

    function formatZipCode(value) {
        const numericValue = value.replace(/\D/g, "");

        if (numericValue.length <= 5) {
            return numericValue;
        } else if (numericValue.length <= 8) {
            return numericValue.replace(/(\d{5})(\d{1,3})/, "$1-$2");
        }

        return numericValue.substring(0, 8).replace(/(\d{5})(\d{1,3})/, "$1-$2");
    }

    function validateZipCode(zipCode) {
        const numericValue = zipCode.replace(/\D/g, "");

        return numericValue.length === 8;
    }

    function showShippingResult(data) {
        const $result = $("#shipping-result");

        $result.html("");

        data.shippingOptions.forEach(option => {
            const texts   = getShippingTexts(option.estimatedDelivery);

            if (option.type === "shipping" && option.available) {
                $result.append(createShippingResultHTML(texts));
            }

            if (option.type === "pickup" && option.available) {
                $result.append(createPickupResultHTML(texts));
            }
        });

        $result.fadeIn(300);
    }

    function calculateShipping() {
        const zipCode = $("#shipping-zipcode").val();
        const texts   = getShippingTexts();

        if (!validateZipCode(zipCode)) {
            alert(texts.errorMessage);
            return;
        }

        checkShippingOptions(zipCode, texts);
    }

    function checkShippingOptions(zipCode, texts) {
        if (!texts.shippingOptionsUrl) return;
        $("#calculate-shipping").addClass("btn-loading");
        $("#shipping-result").html("");

        $.ajax({
            url:     texts.shippingOptionsUrl,
            type:    "GET",
            data:    { zipCode: zipCode.replace(/\D/g, "") },
            success: function (data) {
                showShippingResult(data);
                $("#calculate-shipping").removeClass("btn-loading");
            },
            error: function () {
                showShippingResult(false);
                $("#calculate-shipping").removeClass("btn-loading");
            }
        });
    }

    $(document).on("input", "#shipping-zipcode", function (e) {
        const formattedValue = formatZipCode(e.target.value);

        e.target.value = formattedValue;
    });

    $(document).on("keypress", "#shipping-zipcode", function (e) {
        const charCode = e.which || e.keyCode;

        if (charCode < 48 || charCode > 57) {
            e.preventDefault();
        }
    });

    $(document).on("keypress", "#shipping-zipcode", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            calculateShipping();
        }
    });

    $(document).on("click", "#calculate-shipping", function (e) {
        e.preventDefault();
        calculateShipping();
    });
}

/**
 * ITEM-4292: card "Sua linha tem desconto" — "Com desconto" aplica o cupom do subsídio no
 * carrinho e "Sem desconto" remove. Ao trocar a variação o card é recarregado com o preço do novo pid.
 */
export function subsidyOffer() {
    const $container = $(".js-subsidy-offer");

    if (!$container.length) {
        return;
    }

    $container.on("change", ".js-subsidy-choice", function () {
        const $card = $(this).closest(".js-subsidy-offer-card");
        const data  = { withDiscount: $(this).val() };

        data[$card.data("csrf-name")] = $card.data("csrf-token");

        $.ajax({
            url: $card.data("choice-url"),
            type: "POST",
            data: data
        });
    });

    $("body").on("product:afterAttributeSelect", function (e, response) {
        const product = response && response.data && response.data.product;

        if (!product || !product.id) {
            return;
        }

        const url = new URL($container.data("url"), window.location.origin);

        url.searchParams.set("pid", product.id);

        $.ajax({
            url: url.pathname + url.search,
            type: "GET",
            success: function (html) {
                $container.html(html);
            }
        });
    });
}
